<template>
  <div class="container">
    <!--  表头  -->
    <div class="header">
      <h3>{{ $t("title.Change Title") }}</h3>
      <hr/>
    </div>

    <!--  表格  -->
    <div class="formDiv">
      <el-form ref="form" status-icon :model="form" :rules="rules" label-width="130px" label-position="left">
        <el-form-item :label="$t('Login and Register.Old Password')" prop="oldpassword">
          <el-input type="password" v-model="form.oldpassword" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item :label="$t('Login and Register.New Password')" prop="newpassword">
          <el-input type="password" v-model="form.newpassword" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item :label="$t('Login and Register.Confirm Password')" prop="confirmedPassword">
          <el-input type="password" v-model="form.confirmedPassword" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="returnPage()">{{$t("button.ReturnPage")}}</el-button>
          <el-button type="primary" @click="submitForm('form')">{{ $t("button.Save") }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: "passwordModify",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        if(this.$i18n.locale==='cn'){
          callback(new Error('旧密码不能为空'));
        }
        else{
          callback(new Error('The Old Password cannot be empty'));
        }
      }
      else {
        callback();
      }
    };
    var validatePass1 = (rule, value, callback) => {
      if (value === '') {
        if(this.$i18n.locale==='cn'){
          callback(new Error('新密码不能为空'));
        }
        else{
          callback(new Error('The New Password cannot be empty'));
        }
      } else if(value === this.form.oldpassword){
        if(this.$i18n.locale==='cn'){
          callback(new Error('新密码和旧密码一致'));
        }
        else{
          callback(new Error('The new password is the same as the old one'));
        }
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        if(this.$i18n.locale==='cn'){
          callback(new Error('请再次输入密码'));
        }
        else{
          callback(new Error('Please enter the password again'));
        }
      } else if (value !== this.form.newpassword) {
        if(this.$i18n.locale==='cn'){
          callback(new Error('两次输入密码不一致'));
        }
        else{
          callback(new Error('The passwords entered twice are inconsistent'));
        }
      } else {
        callback();
      }
    };

    return {
      uID: '',
      form: {
        oldpassword: '',
        newpassword: '',
        confirmedPassword: ''
      },
      rules: {
        oldpassword: [
          {required: true, validator: validatePass, trigger: 'blur'}
        ],
        newpassword: [
          {required: true, validator: validatePass1, trigger: 'blur'},
          {min: 3, max: 20, message: this.$t('tips.Modify tips5'), trigger: "blur"}
        ],
        confirmedPassword: [
          {required: true, validator: validatePass2, trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    returnPage(){
      this.$router.push('/Introduction');
    },
    submitForm(form) {
      var that = this
      that.$refs[form].validate((valid) => {
        if (valid) {
          request.post('/user/changepassword?confirmedPassword=' + that.form.confirmedPassword + '&newPassword=' + that.form.newpassword + '&oldPassword=' + that.form.oldpassword).then(function (res) {
            if (res.data.error_message === "success") {
              if (that.$i18n.locale === 'cn') {
                alert("修改成功")
              } else {
                alert("Successful modification")
              }
            } else {
              if (that.$i18n.locale === 'cn') {
                alert("旧密码错误")
              } else {
                alert("The old password is incorrect")
              }
            }
          }).catch(function (err) {
            console.log(err)
          })
        } else {
          if (that.$i18n.locale === 'cn') {
            alert('请根据提示更改信息！');
          } else {
            alert('Please change the information according to the prompts!');
          }
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
.container{
  position:relative;
  width:600px;
  height:600px;
}
.header{
  width: 100%;
  margin:auto;
  position:absolute;
  left:40%;
}
.formDiv{
  width: 100%;
  margin:auto;
  position:absolute;
  left:40%;
  top:15%;
}
</style>